import type { ContactContent } from "../types";
import { renderSectionHeader } from "./section-header";

export function renderContact(contact: ContactContent): string {
  const { form, info } = contact;
  return `
    <section class="section" id="${contact.id}">
      ${renderSectionHeader(contact.header)}
      <div class="contact">
        <form class="contact-form" data-reveal novalidate>
          <label>
            <span>${form.name}</span>
            <input type="text" name="name" autocomplete="name" required />
          </label>
          <label>
            <span>${form.email}</span>
            <input type="email" name="email" autocomplete="email" required />
          </label>
          <label>
            <span>${form.message}</span>
            <textarea name="message" rows="4" required></textarea>
          </label>
          <button type="submit" class="btn solid">${form.submit}</button>
          <p class="form-msg" role="status" aria-live="polite"></p>
        </form>
        <aside class="contact-info" data-reveal>
          <a href="mailto:${info.email}" class="contact-email">${info.email}</a>
          <p class="contact-location">${info.location}</p>
        </aside>
      </div>
    </section>`;
}
